import React, { useEffect, useRef } from "react";
import { View, Animated, ViewStyle } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";

type Props = {
  progress: number;
  containerStyle?: ViewStyle;
  progressBarStyle?: ViewStyle;
  height?: number;
  backgroundColor?: string;
  progressColor?: string;
  animationDuration?: number;
};

export const AnimatedProgressBar: React.FC<Props> = ({
  progress,
  containerStyle,
  progressBarStyle,
  height = 6,
  backgroundColor = "#FFFFFF",
  progressColor = "#0F9129",
  animationDuration = 300,
}) => {
  const animatedWidth = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(animatedWidth, {
      toValue: progress,
      duration: animationDuration,
      useNativeDriver: false, // Width animation cannot use native driver
    }).start();
  }, [progress, animationDuration, animatedWidth]);

  const widthInterpolated = animatedWidth.interpolate({
    inputRange: [0, 100],
    outputRange: ["0%", "100%"],
  });

  return (
    <View
      style={[styles.container, { height, backgroundColor }, containerStyle]}
    >
      <Animated.View
        style={[
          styles.progressBar,
          { height, backgroundColor: progressColor },
          progressBarStyle,
          { width: widthInterpolated },
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    borderRadius: 100,
    overflow: "hidden",
  },
  progressBar: {
    borderRadius: 100,
  },
});
